import { Box, IconButton, SvgIcon, Typography } from '@mui/material';
import React from 'react';

import { palette, spaces } from '../../../../assets/styles/themes/tokens';
import { routes } from '../../../../constants';
import getMuiIcon from '../../../../utils/getMuiIcon';
import useRouter from '../../../../utils/useRouter';

interface AppBarNavProps {
	title: string;
}

const AppBarNav: React.FC<AppBarNavProps> = (props) => {
	const { title } = props;
	const { router } = useRouter();

	const handleLogoClick = () => {
		router.push(`/${routes.dashboard.root}`);
	};

	return (
		<Box
			data-testid="app-bar-nav"
			sx={{
				display: 'flex',
				alignItems: 'center',
				color: palette.background.paperElevation2,
				borderBottom: `1px solid ${palette.elevation.outlined}`,
			}}
		>
			<IconButton
				onClick={handleLogoClick}
				sx={{
					padding: spaces.md,
					borderRadius: 0,
					borderRight: `1px solid ${palette.elevation.outlined}`,
				}}
			>
				<SvgIcon
					sx={{
						width: 32,
						height: 32,
						color: palette.primary.main,
					}}
					viewBox="0 0 32 32"
					component={getMuiIcon('muLogoBag')}
				/>
			</IconButton>
			<Typography
				variant="h6"
				sx={{
					color: palette.text.primary,
					padding: spaces.md,
				}}
			>
				{title}
			</Typography>
		</Box>
	);
};

export default AppBarNav;
